import api from './api';

// Admin Onboarding Review Dashboard (onboarding Module 9).
export const onboardingReviewAPI = {
  submissions: (stage) => api.get('/api/onboarding-review/submissions', { params: stage && stage !== 'all' ? { stage } : {} }),
  bundle: (clientId) => api.get(`/api/onboarding-review/${clientId}`),
  manualIdentity: (clientId, fd) => api.post(`/api/onboarding-review/${clientId}/identity/manual`, fd, { headers: { 'Content-Type': 'multipart/form-data' } }),
  approve: (clientId, body = {}) => api.post(`/api/onboarding-review/${clientId}/approve`, body),
  inviteMember: (clientId, memberClientId, data) => api.post(`/api/onboarding-review/${clientId}/members/${memberClientId}/invite`, data),
  // reuse onboarding reopen for "request more info"
  reopenSection: (clientId, key) => api.post(`/api/onboarding/${clientId}/sections/${key}/reopen`),
};

export const STAGE_META = {
  new: { label: 'New invitations', color: 'bg-blue-100 text-blue-800' },
  in_progress: { label: 'In progress', color: 'bg-amber-100 text-amber-800' },
  documents_pending: { label: 'Documents pending', color: 'bg-orange-100 text-orange-800' },
  submitted: { label: 'Submitted', color: 'bg-indigo-100 text-indigo-800' },
  needs_review: { label: 'Needs review', color: 'bg-rose-100 text-rose-800' },
  ready_for_setup: { label: 'Ready for setup', color: 'bg-accent text-accent-foreground' },
  completed: { label: 'Completed', color: 'bg-green-100 text-green-800' },
};
